// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt

// shopping cart
frappe.provide("webshop.webshop.shopping_cart");
var shopping_cart = webshop.webshop.shopping_cart;

var getParams = function (url) {
	var params = [];
	var parser = document.createElement('a');
	parser.href = url;
	var query = parser.search.substring(1);
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		params[pair[0]] = decodeURIComponent(pair[1]);
	}
	return params;
};

frappe.ready(function() {
	var full_name = frappe.session && frappe.session.user_fullname;
	// update user
	if(full_name) {
		$('.navbar li[data-label="User"] a')
			.html('<i class="fa fa-fixed-width fa fa-user"></i> ' + full_name);
	}
	// set coupon code and sales partner code

	var url_args = getParams(window.location.href);

	var referral_coupon_code = url_args['cc'];
	var referral_sales_partner = url_args['sp'];

	var d = new Date();
	// expires within 30 minutes
	d.setTime(d.getTime() + (0.02 * 24 * 60 * 60 * 1000));
	var expires = "expires="+d.toUTCString();
	if (referral_coupon_code) {
		document.cookie = "referral_coupon_code=" + referral_coupon_code + ";" + expires + ";path=/";
	}
	if (referral_sales_partner) {
		document.cookie = "referral_sales_partner=" + referral_sales_partner + ";" + expires + ";path=/";
	}
	referral_coupon_code=frappe.get_cookie("referral_coupon_code");
	referral_sales_partner=frappe.get_cookie("referral_sales_partner");

	if (referral_coupon_code && $(".tot_quotation_discount").val()==undefined ) {
		$(".txtcoupon").val(referral_coupon_code);
	}
	if (referral_sales_partner) {
		$(".txtreferral_sales_partner").val(referral_sales_partner);
	}

	// update login
	shopping_cart.show_shoppingcart_dropdown();
	shopping_cart.set_cart_count();
	shopping_cart.show_cart_navbar();
});

$.extend(shopping_cart, {
	show_shoppingcart_dropdown: function() {
		$(".shopping-cart").on('shown.bs.dropdown', function() {
			if (!$('.shopping-cart-menu .cart-container').length) {
				return frappe.call({
					method: 'webshop.webshop.shopping_cart.cart.get_shopping_cart_menu',
					callback: function(r) {
						if (r.message) {
							$('.shopping-cart-menu').html(r.message);
						}
					}
				});
			}
		});
	},

	update_cart: function(opts) {
		shopping_cart.freeze();
		return frappe.call({
			type: "POST",
			method: "webshop.webshop.shopping_cart.cart.update_cart",
			args: {
				item_code: opts.item_code,
				qty: opts.qty,
				additional_notes: opts.additional_notes !== undefined ? opts.additional_notes : undefined,
				with_items: opts.with_items || 0,
				add_qty: opts.add_qty || false,
				//// Neoffice — multi-warehouse: stock source of the cart line
				//// (undefined = server resolves, historical behaviour).
				warehouse: opts.warehouse !== undefined ? opts.warehouse : undefined
			},
			btn: opts.btn,
			callback: function(r) {
				shopping_cart.unfreeze();
				shopping_cart.set_cart_count(true);
				//// Neoffice — the Builder shop's cart is a header drawer with its own badge,
				//// outside this bundle; it never heard about an add made from a product card,
				//// so neither the drawer nor its badge moved. Tell it a cart change happened:
				//// its badge follows, and on a real add (open_drawer) it opens with its
				//// animation. A plain webshop navbar has no listener and ignores this.
				//// (2026-09-07)
				try {
					document.dispatchEvent(new CustomEvent("webshop:cart-changed", {
						detail: { open: !!opts.open_drawer, item_code: opts.item_code, qty: opts.qty }
					}));
				} catch (e) { /* no CustomEvent support: nothing to notify */ }
				if(opts.callback)
					opts.callback(r);
			}
		//// Neoffice — upstream refuses the whole update_cart to a guest and redirects to
		//// /login. With enable_guest_cart the call goes through for everyone; the guest
		//// redirect now happens only where a shop really requires an account (see the
		//// bind_add_to_cart_action block below). 3bc2d836f1, 2025-02-11.
		});
	},

	set_cart_count: function(animate=false) {
		$(".intermediate-empty-cart").remove();

		//// Neoffice — upstream forces the badge to 0 for a guest. A guest has a real cart
		//// here, so the cookie is read like for anyone else.
		var cart_count = frappe.get_cookie("cart_count");

		if(cart_count) {
			$(".shopping-cart").toggleClass('hidden', false);
		}

		var $cart = $('.cart-icon');
		var $badge = $cart.find("#cart-count");

		if(parseInt(cart_count) === 0 || cart_count === undefined) {
			$cart.css("display", "none");
			$(".cart-tax-items").hide();
			$(".btn-place-order").hide();
			$(".cart-payment-addresses").hide();

			let intermediate_empty_cart_msg = `
				<div class="text-center w-100 intermediate-empty-cart mt-4 mb-4 text-muted">
					${ __("Cart is Empty") }
				</div>
			`;
			$(".cart-table").after(intermediate_empty_cart_msg);
		}
		else {
			$cart.css("display", "inline");
			$("#cart-count").text(cart_count);
		}

		if(cart_count) {
			$badge.html(cart_count);

			if (animate) {
				$cart.addClass("cart-animate");
				setTimeout(() => {
					$cart.removeClass("cart-animate");
				}, 500);
			}
		} else {
			$badge.remove();
		}
	},

	//// Neoffice — multi-warehouse: `warehouse` identifies the targeted cart
	//// line (same item can exist once per stock source).
	shopping_cart_update: function({item_code, qty, cart_dropdown, additional_notes, warehouse}) {
		// Check if a coupon or loyalty points are applied before updating the cart
		frappe.call({
			method: 'webshop.webshop.shopping_cart.cart.get_cart_quotation',
			callback: (r) => {
				if (r.message && r.message.doc) {
					const doc = r.message.doc;
					// Check if a coupon or loyalty points are applied
					if (doc.coupon_code || doc.gift_card_coupon) {
						// Remove the coupon before updating the quantity
						frappe.call({
							method: 'webshop.webshop.shopping_cart.cart.remove_coupon_code',
							callback: (r) => {
								if (r.message) {
									frappe.show_alert({
										message: __('The coupon has been removed to update the cart'),
										indicator: 'blue'
									});
									// Continue with the cart update
									shopping_cart.perform_cart_update({item_code, qty, cart_dropdown, additional_notes, warehouse});
								}
							}
						});
					} else if (doc.loyalty_points) {
						// Remove loyalty points before updating the quantity
						frappe.call({
							method: 'webshop.webshop.shopping_cart.cart.remove_loyalty_points',
							callback: (r) => {
								if (r.message) {
									frappe.show_alert({
										message: __('The loyalty points have been removed to update the cart'),
										indicator: 'blue'
									});
									// Continue with the cart update
									shopping_cart.perform_cart_update({item_code, qty, cart_dropdown, additional_notes, warehouse});
								}
							}
						});
					} else {
						// No coupon or loyalty points, update directly
						shopping_cart.perform_cart_update({item_code, qty, cart_dropdown, additional_notes, warehouse});
					}
				} else {
					// No cart data, update directly
					shopping_cart.perform_cart_update({item_code, qty, cart_dropdown, additional_notes, warehouse});
				}
			}
		});
	},

	// Auxiliary function to update the cart
	perform_cart_update: function({item_code, qty, cart_dropdown, additional_notes, warehouse}) {
		shopping_cart.update_cart({
			item_code,
			qty,
			additional_notes,
			//// Neoffice — the chosen warehouse travels with the line: with multi-warehouse the
			//// same product can be in the cart twice, from two sources (5bf2e88a1b,
			//// 2026-08-25).
			warehouse,
			with_items: 1,
			btn: this,
			callback: function(r) {
				if(!r.exc) {
					$(".cart-items").html(r.message.items);
					$(".cart-tax-items").html(r.message.total);
					$(".payment-summary").html(r.message.taxes_and_totals);
					shopping_cart.set_cart_count();

					if (cart_dropdown != true) {
						$(".cart-icon").hide();
					}
//// Neoffice — added. Upstream replaces the items table in place; on /cart the page
//// is more than that table — the empty-cart message, the totals and the checkout
//// button live outside it — so removing the last line left a screen that was half
//// true (1c8afc025a, 2026-08-03 "recharger quand la derniere ligne s'en va").

					// The cart just lost its last line: reload. The cart page is
					// more than the table — "Your cart is empty", the checkout
					// button and the summary live elsewhere — so replacing only the
					// table left a screen that was half true: not a single line
					// left, but still a total and a "Proceed to checkout" button.
					const $rows = $(".cart-items").find("tr[data-name]");
					if (!$rows.length && window.location.pathname.indexOf("/cart") === 0) {
						window.location.reload();
					}
				}
			},
		});
	},

	show_cart_navbar: function () {
		frappe.call({
			method: "webshop.webshop.doctype.webshop_settings.webshop_settings.is_cart_enabled",
			callback: function(r) {
				$(".shopping-cart").toggleClass('hidden', r.message ? false : true);
			}
		});
	},

	toggle_button_class(button, remove, add) {
		button.removeClass(remove);
		button.addClass(add);
	},

	bind_add_to_cart_action() {
		$('.page_content').on('click', '.btn-add-to-cart-list', (e) => {
			const $btn = $(e.currentTarget);
			$btn.prop('disabled', true);

			if (frappe.session.user==="Guest") {
				//// Neoffice — upstream sends every guest to /login. The shop's own setting decides:
				//// with enable_guest_cart the item is added and the buy button flips to "go to
				//// cart" exactly as for a signed-in buyer; without it, the upstream redirect is
				//// kept (3bc2d836f1, 2025-02-11).
				frappe.call({
					method: 'webshop.webshop.doctype.webshop_settings.webshop_settings.get_shopping_cart_settings',
					callback: function(r) {
						if (!r.message.enable_guest_cart) {
							if (localStorage) {
								localStorage.setItem("last_visited", window.location.pathname);
							}
							frappe.call('webshop.webshop.api.get_guest_redirect_on_action').then((res) => {
								window.location.href = res.message || "/login";
							});
							return;
						}
						
						// Guest cart is enabled, add to cart
						const item_code = $btn.data('item-code');
						
						webshop.webshop.shopping_cart.update_cart({
							item_code,
							qty: 1,
							//// Neoffice — adding from a shop card opens the Builder drawer (2026-09-07)
							open_drawer: true,
							callback: function(r) {
								if (r.message && r.message.error) {
									frappe.msgprint({
										title: __('Error'),
										message: r.message.error,
										indicator: 'red'
									});
									$btn.prop('disabled', false);
									return;
								}

								$btn.addClass('hidden');
								$btn.closest('.cart-action-container').addClass('d-flex');
								$btn.parent().find('.go-to-cart').removeClass('hidden');
								$btn.parent().find('.go-to-cart-grid').removeClass('hidden');
								$btn.parent().find('.cart-indicator').removeClass('hidden');
							}
						});
					}
				});
				return;
			}

			$btn.addClass('hidden');
			$btn.closest('.cart-action-container').addClass('d-flex');
			$btn.parent().find('.go-to-cart').removeClass('hidden');
			$btn.parent().find('.go-to-cart-grid').removeClass('hidden');
			$btn.parent().find('.cart-indicator').removeClass('hidden');

			const item_code = $btn.data('item-code');
			webshop.webshop.shopping_cart.update_cart({
				item_code,
				qty: 1,
				//// Neoffice — adding from a shop card opens the Builder drawer (2026-09-07)
				open_drawer: true
			});

		});
	},

	freeze() {
		if (window.location.pathname !== "/cart") return;

		if (!$('#freeze').length) {
			let freeze = $('<div id="freeze" class="modal-backdrop fade"></div>')
				.appendTo("body");

			setTimeout(function() {
				freeze.addClass("show");
			}, 1);
		} else {
			$("#freeze").addClass("show");
		}
	},

	unfreeze() {
		if ($('#freeze').length) {
			let freeze = $('#freeze').removeClass("show");
			setTimeout(function() {
				freeze.remove();
			}, 1);
		}
	}
});
